import { Link, useLocation, useNavigate } from 'react-router-dom';
import { User, Heart, Home, CircleUser } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function BottomNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleHomeClick = (e) => {
    e.preventDefault();
    if (location.pathname === '/chat-list') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/chat-list');
    }
  };

  const isLeftActive = location.pathname === '/contacts';
  const isMiddleActive = location.pathname === '/chat-list' || location.pathname === '/notifications';
  const isRightActive = location.pathname === '/profile';

  const activeColor = '#008080';
  const inactiveColor = '#757575'; // Gray for inactive

  return (
    <nav className="bg-[#FFFDF5]/90 backdrop-blur-md fixed bottom-0 w-full max-w-[480px] left-1/2 -translate-x-1/2 z-50 shadow-[0px_-4px_20px_rgba(0,128,128,0.05)] border-t border-surface-container-high/30">
      <div className="flex justify-around items-center px-lg py-sm pb-safe pt-2">
        
        {/* Left Tab - Friends / Settings */}
        <Link to="/contacts" className="flex flex-col items-center justify-center px-4 py-1 rounded-full transition-colors active:scale-90 transition-transform">
          <div className="relative w-[28px] h-[28px] flex items-center justify-center mb-1">
            <User color={isLeftActive ? activeColor : inactiveColor} size={26} strokeWidth={2} />
            {/* 우상단 톱니바퀴 (설정) */}
            <div className="absolute -top-0.5 -right-1.5 z-10 flex items-center justify-center">
              <svg
                className="w-[16px] h-[16px]"
                viewBox="0 0 24 24"
                fill={isLeftActive ? activeColor : inactiveColor}
                aria-hidden="true"
              >
                {/* ① 분리 링: 반지름 11의 원 (탭바 배경색 #FFFDF5) */}
                <circle cx="12" cy="12" r="11" fill="#FFFDF5" />
                {/* ② 톱니 6개: 폭 6, 높이 22, 모서리 반경 3의 둥근 사각형 3개 (0도, 60도, 120도 회전) */}
                <rect x="9" y="1" width="6" height="22" rx="3" />
                <rect x="9" y="1" width="6" height="22" rx="3" transform="rotate(60 12 12)" />
                <rect x="9" y="1" width="6" height="22" rx="3" transform="rotate(120 12 12)" />
                {/* ③ 몸통: 반지름 7의 원 */}
                <circle cx="12" cy="12" r="7" />
                {/* ④ 중심 구멍: 반지름 2.5의 원 (탭바 배경색 #FFFDF5) */}
                <circle cx="12" cy="12" r="2.5" fill="#FFFDF5" />
              </svg>
            </div>
            {/* 우하단 하트 (친구) */}
            <div className="absolute -bottom-1 -right-1 bg-[#FFFDF5] rounded-full p-[2px]">
              <Heart color={isLeftActive ? activeColor : inactiveColor} size={12} strokeWidth={2.5} />
            </div>
          </div>
          <span className={`font-label-md text-xs font-medium whitespace-nowrap ${isLeftActive ? 'text-[#008080]' : 'text-[#757575]'}`}>{t('nav.friends')}</span>
        </Link>

        {/* Middle Tab - Home */}
        <button onClick={handleHomeClick} className="flex flex-col items-center justify-center px-4 py-1 rounded-full transition-colors active:scale-90 transition-transform">
          <div className="w-[28px] h-[28px] flex items-center justify-center mb-1">
            <Home color={isMiddleActive ? activeColor : inactiveColor} size={26} strokeWidth={2} />
          </div>
          <span className={`font-label-md text-xs font-medium ${isMiddleActive ? 'text-[#008080]' : 'text-[#757575]'}`}>{t('nav.home')}</span>
        </button>

        {/* Right Tab - Profile */}
        <Link to="/profile" className="flex flex-col items-center justify-center px-4 py-1 rounded-full transition-colors active:scale-90 transition-transform">
          <div className="w-[28px] h-[28px] flex items-center justify-center mb-1">
            <CircleUser color={isRightActive ? activeColor : inactiveColor} size={26} strokeWidth={2} />
          </div>
          <span className={`font-label-md text-xs font-medium ${isRightActive ? 'text-[#008080]' : 'text-[#757575]'}`}>{t('nav.profile')}</span>
        </Link>

      </div>
    </nav>
  );
}
